import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { OperatorPlanningBuilder } from '../../models/builders/operator-planning.builder';
import { OperatorGroupPlanning, OperatorWeeklyPlanning, OperatorWeekShift } from '../../models/operator-planning';
import { mapCollection } from '../../utils/collection.utils';
import { valueOf } from '../../utils/string.utils';

const planningBody = (planning: OperatorWeeklyPlanning) => ({
  year: planning.year,
  groups: mapCollection((group: OperatorGroupPlanning) => ({
    operatorGroupHash: group.operatorGroup.hash,
    shifts: mapCollection((shift: OperatorWeekShift) => ({ week: shift.week, shift: shift.shift || '' }), group.shifts || [])
  }), planning.groups || [])
});

@Injectable()
export class OperatorPlanningApiService {

  private apiUrl: string;

  constructor(private httpClient: HttpClient) {
    this.apiUrl = `${ environment.apiUrl }working-model-groups`;
  }

  getWeeklyPlanning(machineGroupHash: string, year: number) {
    const params = new HttpParams().append('year', valueOf(year));

    return this.httpClient.get(`${ this.apiUrl }/${ machineGroupHash }/operator-planning`, { params })
      .pipe(
        map(OperatorPlanningBuilder.fromJson)
      );
  }

  saveWeeklyPlanning(machineGroupHash: string, planning: OperatorWeeklyPlanning) {
    return this.httpClient.put(`${ this.apiUrl }/${ machineGroupHash }/operator-planning`, planningBody(planning))
      .pipe(
        map(OperatorPlanningBuilder.fromJson)
      );
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/services/api/operator-planning-api.service.ts